import { GET_PRESENTATION_PAGE, HIDE_PRESENTATION_PAGE, URL_CHANGED } from './constants';

export const getPresentationPage = (pageType, opts) => ({type: GET_PRESENTATION_PAGE, pageType, opts });
export const hidePresentationPage = () => ({type: HIDE_PRESENTATION_PAGE });
export const urlChanged = (url) => ({type: URL_CHANGED, url });